<template>
  <div class="video-player-container">
    <video ref="videoRef" class="video-content" :src="videoUrl" controls autoplay controlslist="nodownload" playsinline
      @ended="playEnd"></video>
  </div>
</template>

<script>
import store from '@/store/index'
export default {
  name: 'VideoPlayer',
  props: {
    videoList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      videoSource: [],
      videoUrl: '',
      curPlayIndex: 0,
      client_gate: store.state.auth.CLIENT_CONFIG.client_gate
    }
  },
  mounted() {
    const videoElement = this.$refs.videoRef;
    if (!videoElement) return;

    try {
      videoElement.play();
    } catch (error) {
      console.warn('自动播放失败（浏览器策略限制）：', error.message);
      console.warn('解决方案：保留video标签的muted属性，确保浏览器允许自动播放');
    }
  },
  methods: {
    playEnd() {
      console.log('视频播放结束');
      if (this.videoSource.length === 0) {
        console.warn('视频列表为空，无法继续播放');
        return;
      }

      // 1. 修正索引自增逻辑（核心错误）
      if (this.curPlayIndex >= this.videoSource.length - 1) {
        console.log('已播放完所有视频，重新开始');
        this.curPlayIndex = 0;
      } else {
        // 错误：this.curPlayIndex + 1; 改为赋值操作
        this.curPlayIndex += 1;
        console.log('开始播放' + this.videoSource[this.curPlayIndex].hres_path);
      }

      // 2. 先赋值新URL，再触发播放（移除无意义的清空操作）
      this.videoUrl = this.client_gate + '/file/preview/' + this.videoSource[this.curPlayIndex].hres_path;

      // 3. 等待DOM更新后，主动调用播放方法
      this.$nextTick(() => {
        const videoElement = this.$refs.videoRef;
        if (videoElement) {
          try {
            videoElement.play(); // 切换视频后主动触发播放
          } catch (error) {
            console.warn('切换视频自动播放失败：', error.message);
          }
        }
      });
    }
  },
  watch: {
    videoList: {
      immediate: true,
      handler(newVal) {
        if (newVal.length > 0) {
          console.log(newVal);
          this.videoSource = []; // 先清空，避免多次触发时重复添加
          for (let i = 0; i < newVal.length; i++) {
            for (let j = 0; j < Number(newVal[i].playCount); j++) {
              this.videoSource.push(newVal[i]);
            }
          }

          this.videoUrl = this.client_gate + '/file/preview/' + this.videoSource[0].hres_path;
          this.curPlayIndex = 0;
          console.log(this.videoUrl);

          // 初始化时也触发播放（可选，增强鲁棒性）
          this.$nextTick(() => {
            const videoElement = this.$refs.videoRef;
            if (videoElement) videoElement.play();
          });
        }
      }
    }
  }
}
</script>

<style scoped>
.video-player-container {
  width: 100%;
  border-radius: 0.1rem;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.video-content {
  width: 100%;
  /* height: auto; */
  height: 100%;
  object-fit: contain;
  border-radius: 0.1rem;
  display: block;
  background-color: #ffffff;
  
}
</style>